export const getHostURL = (): string => {
  const { hostname, port, protocol } = window.location

  if (port && port === '80') {
    return `${protocol}://${hostname}`
  }

  return `${protocol}//${hostname}:${port}`
}
